// @flow
import gql from 'graphql-tag'
import { type Media, MEDIA_FRAGMENT } from 'gql/media'

export type ProfileMedia = {
  caption: string | null,
  index: number,
  media: Media,
}

export const PROFILE_MEDIA_FRAGMENT = gql`
  fragment profileMedia on ProfileMedia {
    caption
    index
    media {
      ...media
    }
  }

  ${MEDIA_FRAGMENT}
`
